<template>
  <div v-if="request" class="vue-aside" :class="{ 'with-top-bar': hasTopBar }">
    <div class="vue-aside-backdrop"></div>
    <div class="vue-aside-dialog">
      <!--
        The slide-out panel. Rendered by the Vue root (App.vue), driven from `SliderService` -
        an Angular service with no Vue reactivity - through `services.sliderHost`. `BookingSlider`
        and `IncompleteBookingsSlider` are the two hosts; each holds what its Angular controller
        used to and renders the existing component.
      -->
      <component :is="request.component" v-bind="request.props" v-on:close="finish" v-on:dismiss="abort" />
    </div>
  </div>
</template>

<script>
import { markRaw } from 'vue'

import sliderHostStore from '../../common/service/sliderHostStore.js'
import BookingSlider from '../../booking/component/bookingSlider.vue'
import IncompleteBookingsSlider from '../../incompleteBookings/component/incompleteBookingsSlider.vue'
import ResourceSelectionSlider from '../../resourceSelection/component/resourceSelectionSlider.vue'

// Every slide-out is Vue now (step 35b of #614). `template` is the name `SliderService` is called
// with, kept so its callers did not have to change.
const SLIDERS = {
  'booking.html': BookingSlider,
  'incompleteBookings.html': IncompleteBookingsSlider,
  'resourceSelection.html': ResourceSelectionSlider,
}

export default {
  name: 'SliderHost',
  data() {
    return {
      request: null,
      resolve: null,
      reject: null,
    }
  },
  computed: {
    // The old `$aside` added `with-top-bar` when the fixed search header was on screen (app.css
    // keys the 60px offset off it). The header only exists on the resources page now.
    hasTopBar() {
      return this.$route.name === 'resources'
    },
  },
  created() {
    sliderHostStore.register(this)
  },
  beforeUnmount() {
    sliderHostStore.unregister(this)
  },
  methods: {
    // Opens a slide-out and resolves when it closes (`finish`), rejects when it is dismissed
    // (`abort`) - the same contract as `$aside.open(...).result`.
    open({ template, props }) {
      const component = SLIDERS[template]
      if (!component) {
        return Promise.reject(new Error(`Unknown slider ${template}`))
      }

      // Only one at a time. A second open while one is up is a bug, but do not leak the first
      // caller's promise for ever - dismiss it.
      if (this.reject) {
        this.abort()
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
        // markRaw: `request` is reactive data, and a component definition made reactive makes Vue
        // warn and does pointless work tracking a static object on every render.
        this.request = { component: markRaw(component), props: props || {} }
      })
    },
    finish(result) {
      const resolve = this.resolve
      this.clear()
      if (resolve) {
        resolve(result)
      }
    },
    abort() {
      const reject = this.reject
      this.clear()
      if (reject) {
        reject()
      }
    },
    clear() {
      this.request = null
      this.resolve = null
      this.reject = null
    },
  },
}
</script>
